export const alertColumns = (t) => [
  { field: "platformName", header: t("ALERTS.COLUMNS.PLATFORM") },
  { field: "protocolId", header: t("ALERTS.COLUMNS.PROTOCOL_ID") },
  { field: "clientName", header: t("ALERTS.COLUMNS.CLIENT") },
  { field: "phone1", header: t("ALERTS.COLUMNS.PHONE") },
  { field: "phone2", header: t("ALERTS.COLUMNS.PHONE_2") },
  { field: "eventDate", header: t("ALERTS.COLUMNS.EVENT_DATE") },
  { field: "protocolSubtype", header: t("ALERTS.COLUMNS.SUBTYPE") },
  { field: "licensePlate", header: t("ALERTS.COLUMNS.PLATE") },
  { field: "location", header: t("ALERTS.COLUMNS.LOCATION") },
  { field: "protocolStatus", header: t("ALERTS.COLUMNS.STATUS") },
  { field: "lastUpdateDate", header: t("ALERTS.COLUMNS.LAST_UPDATE") },
];
